import { useQuery } from '@hooks/reactQuery';

import { getGnbIdsBranch } from '@api/configurationComparison';

import { extractQueryParams } from '@utils/common';
import { fieldsOptionsFormatted } from '@utils/formatter';

import { TSelectOption } from '@interfaces/components/componentTypes';

import { refetchOptions } from '@constants/common';
import { MO_BRANCH_GNB_IDS } from '@constants/queryKeys';

interface IUseQueryGnbIdsBranchReturnType {
	gnbIdsOptions: TSelectOption[];
	isLoadingGnbIds: boolean;
}

export const useQueryGnbIdsBranch = (comparisonId: string): IUseQueryGnbIdsBranchReturnType => {
	const {
		data: gnbIdsOptions,
		isLoading: isLoadingGnbIds,
	} = useQuery({
		queryKey: [MO_BRANCH_GNB_IDS, comparisonId],
		queryFn: extractQueryParams(getGnbIdsBranch),
		select: (options: Array<string>) => fieldsOptionsFormatted(options),
		...refetchOptions,
	});

	return { gnbIdsOptions: gnbIdsOptions || [], isLoadingGnbIds };
};
